import createDeliveryDays from "../utils/createDeliveryDays"
import generateFilterQuery from "../utils/generateFilterQuery"
import debounce from "../utils/debounce"

export const state = () => ({
  accountLoading: true,
  allergens: false,
  authenticated: false,
  authLoading: false,
  customerLoading: false,
  customerRole: false,
  billingAddress: false,
  bundles: false,
  cart: false,
  cartError: false,
  checkoutError: false,
  cartLoading: false,
  chosenCuisine: false,
  chosenDeal: false,
  chosenProduct: false,
  chosenMaker: false,
  chosenMakerCategory: false,
  chosenOrder: false,
  chosenPackage: false,
  cuisines: false,
  customer: false,
  dealId: false,
  deliveryAddress: false,
  deliveryFilter: false,
  deliveryLoading: false,
  deliveryNotes: false,
  deliveryWindows: false,
  discountError: false,
  discount: false,
  discountLoading: false,
  filteredMakers: false,
  filteredProductCategories: false,
  isProduction: process.env.APP_ENV === "production",
  locatorIsOpen: false,
  loginError: false,
  makers: false,
  makerCategories: false,
  makerLoading: false,
  makersLoading: true,
  makerCategoriesLoading: true,
  newVerificationError: false,
  newVerificationSuccess: false,
  orderNotes: false,
  order: false,
  orders: false,
  ordersLoading: false,
  organisationLoading: false,
  organisation: false,
  organisationOrders: false,
  organisationOrderProducts: false,
  packages: false,
  packageCart: {
    packages: [],
    items: [],
    maker: false,
    date: false,
  },
  packagesLoading: false,
  products: false,
  productCategories: false,
  resetConfirmation: false,
  resetPasswordError: false,
  resetPasswordSuccess: false,
  reviews: false,
  reviewMessage: false,
  reviewsLoading: false,
  rewards: false,
  rewardsLoading: false,
  rewardSelected: false,
  searchResults: false,
  showAccount: false,
  showCalendar: false,
  showCart: false,
  showMenus: false,
  showOptions: false,
  showSearch: false,
  showServices: false,
  signUpSuccess: false,
  signUpError: false,
  socialSharing: [
    {
      network: "email",
      icon: "envelope",
    },
    {
      network: "whatsapp",
      icon: "whatsapp",
    },
    {
      network: "facebook",
      icon: "facebook",
    },
    {
      network: "twitter",
      icon: "x-twitter",
    },
    {
      network: "linkedin",
      icon: "linkedin",
    },
  ],
  tags: false,
  testMakers: [
    "78f6dcdf-de74-48c9-8f67-ec08cc0f78e0",
    "9f4a8647-4a48-4307-9f05-600fd8d071b0",
  ],
  user: false,
  verifySuccess: false,
  verifyError: false,
  verificationLoading: false,
  windowSize: 0,
  paymentLoading: false,
  purchaseOrderLoading: false,
  purchaseOrderError: false,
  orgPackageChoices: false,
  subscriptionTypes: false,
  templateLoading: true,
  packageTypes: false,
  defaultPackageChoices: false,
  updateProductsLoading: false,
  updateProductsError: false,
  cancelDailyOrderLoading: false,
  cancelDailyOrderError: false,
  premiumCutOffDay: false,
  appendProductsLoading: false,
  appendProductsError: false,
})

export const mutations = {
  SET_TEMPLATE_LOADING(state, payload) {
    state.templateLoading = payload
  },
  SET_MAKERS_LOADING(state, payload) {
    state.makersLoading = payload
  },
  SET_MAKER_CATEGORIES_LOADING(state, payload) {
    state.makerCategoriesLoading = payload
  },
  SET_MAKER_LOADING(state, payload) {
    state.makerLoading = payload
  },
  SET_AUTH_LOADING(state, payload) {
    state.authLoading = payload
  },
  SET_REVIEWS_LOADING(state, payload) {
    state.reviewsLoading = payload
  },
  SET_PRODUCT_CATEGORIES(state, payload) {
    state.productCategories = payload.filter(
      (category) =>
        category.is_active &&
        category.biz &&
        category.products.length > 0 &&
        category.products.some((product) => product.is_active)
    )
  },
  SET_FILTERED_PRODUCT_CATEGORIES(state, payload) {
    if (payload) {
      state.filteredProductCategories = state.productCategories.map(
        (category) => {
          return {
            ...category,
            products: category.products.filter((product) => {
              return payload.every((allergen) =>
                allergen.list
                  ? product.allergens.every(
                      (item) => !allergen.list.includes(item.name)
                    ) &&
                    allergen.list.every(
                      (item) =>
                        !product.name.toLowerCase().includes(item) &&
                        !product.description.toLowerCase().includes(item)
                    )
                  : product[allergen.toggle]
              )
            }),
          }
        }
      )
    } else {
      state.filteredProductCategories = payload
    }
  },
  SET_SEARCH_STATUS(state, payload) {
    state.showSearch = payload
  },
  SET_CALENDAR_STATUS(state, payload) {
    state.showCalendar = payload
  },
  SET_OPTIONS_STATUS(state, payload) {
    state.showOptions = payload
  },
  SET_SHOW_MENUS(state, payload) {
    state.showMenus = payload
  },
  SET_SHOW_SERVICES(state, payload) {
    state.showServices = payload
  },
  SET_SHOW_ACCOUNT(state, payload) {
    state.showAccount = payload
  },
  SET_CART_STATUS(state, payload) {
    state.showCart = payload
    state.showOptions = false
    state.showSearch = false
    state.showCalendar = false
    window.scrollTo(0, 0)
  },
  SET_BUNDLES(state, payload) {
    state.bundles = payload.filter(
      (bundle) => bundle.is_active && bundle.type === "Bundle"
    )
  },
  SET_PACKAGES_LOADING(state, payload) {
    state.packagesLoading = payload
  },
  SET_PACKAGES(state, payload) {
    state.packages = payload
  },
  SET_PACKAGE_CART(state, payload) {
    state.packageCart = payload
  },
  SET_CHOSEN_PACKAGE(state, payload) {
    state.chosenPackage = payload
  },
  SET_CHOSEN_PRODUCT(state, payload) {
    state.chosenProduct = payload
  },
  SET_ALLERGENS(state, payload) {
    state.allergens = payload
  },
  SET_CUISINES(state, payload) {
    state.cuisines = payload
  },
  SET_TAGS(state, payload) {
    state.tags = payload
  },
  SET_SEARCH_RESULTS(state, payload) {
    if (state.isProduction) {
      state.searchResults = payload.filter(
        (result) => !state.testMakers.includes(result.id)
      )
    } else {
      state.searchResults = payload
    }
    if (payload) {
      state.showCalendar = false
      state.showOptions = false
    }
  },
  SET_CHOSEN_CUISINE(state, payload) {
    state.chosenCuisine = payload
  },
  SET_ORDER(state, payload) {
    state.order = payload
    if (payload.id) {
      localStorage.setItem(payload.id, JSON.stringify(payload))
    }
  },
  SET_ORDER_NOTES(state, payload) {
    state.orderNotes = payload
    state.cart = { ...state.cart, orderNotes: payload }
  },
  SET_DELIVERY_NOTES(state, payload) {
    state.deliveryNotes = payload
    state.cart = { ...state.cart, deliveryNotes: payload }
  },
  SET_DELIVERY_DATE(state, payload) {
    const newCart = {
      ...state.cart,
      items: state.cart.items.filter((item) => item.product.future_day),
      date: payload,
    }
    state.cart = newCart
    state.cartError = payload?.selectedWindow
      ? false
      : "Please select a date and time"
  },
  SET_DELIVERY_FILTER(state, payload) {
    state.deliveryFilter = payload

    const makersFromCategories = state.makerCategories.flatMap((cat) =>
      cat.makers.map((maker) => createDeliveryDays(maker, state.cart))
    )

    const uniqueMakers = Array.from(
      new Map(makersFromCategories.map((maker) => [maker.id, maker])).values()
    )
    const sourceMakers = state.makers.length ? state.makers : uniqueMakers
    if (payload) {
      state.filteredMakers = sourceMakers.filter((maker) =>
        maker.delivery_days?.find(
          (day) => day.full === payload.full && day.available
        )
      )
      if (state.cart) {
        state.cart = { ...state.cart, date: payload }
      }
    }
  },
  SET_SELECTED_WINDOW(state, payload) {
    const newCart = {
      ...state.cart,
      date: { ...state.cart.date, selectedWindow: payload },
    }
    state.cart = newCart
    state.cartError = false
  },
  SET_DELIVERY_WINDOWS(state, payload) {
    const windows = []

    const today = this.$moment().startOf("day")

    const startCutOff = today.clone().hour(7).minute(0)
    const endCutOff = today.clone().hour(19).minute(0)

    const rawStart = payload?.openTime
      ? today
          .clone()
          .hour(parseInt(payload.openTime.split(":")[0]))
          .minute(parseInt(payload.openTime.split(":")[1]))
      : startCutOff

    const rawEnd = payload?.closeTime
      ? today
          .clone()
          .hour(parseInt(payload.closeTime.split(":")[0]))
          .minute(parseInt(payload.closeTime.split(":")[1]))
      : endCutOff

    const startTime = rawStart.isAfter(startCutOff) ? rawStart : startCutOff
    const endTime = rawEnd.isBefore(endCutOff) ? rawEnd : endCutOff

    const current = startTime.clone()

    while (current.isSameOrBefore(endTime)) {
      const windowStart = current.format("HH:mm")
      windows.push({
        name: windowStart,
        value: windowStart,
      })
      current.add(30, "minutes")
    }

    state.deliveryWindows = windows
    if (state.cart) {
      state.cart.date = {
        ...state.cart.date,
        deliveryWindows: windows,
      }
    }
  },
  SET_LOGIN_ERROR(state, payload) {
    // TODO: Make this more robust, we should be presenting error messages based on unique error codes/ids that we send from the BE
    if (payload === "Customer account not activated") {
      state.loginError =
        "Your account needs to be verified, please check your email for instructions to verify or go to https://anddine.co.uk/verify/new to request a new verification email."
    } else {
      state.loginError = payload
    }
  },
  SET_SIGN_UP_SUCCESS(state, payload) {
    state.signUpSuccess = payload
  },
  SET_SIGN_UP_ERROR(state, payload) {
    state.signUpError = payload
  },
  SET_VERIFY_ERROR(state, payload) {
    state.verifyError = payload
  },
  SET_VERIFY_SUCCESS(state, payload) {
    state.verifySuccess = payload
  },
  SET_AUTHENTICATED(state, payload) {
    state.authenticated = payload
    state.customerRole = payload?.role || false
    localStorage.setItem("authenticated", JSON.stringify(payload))
  },
  SET_DELIVERY_ADDRESS(state, payload) {
    state.deliveryAddress = payload
    payload && localStorage.setItem("address", JSON.stringify(payload))
    state.cart = { ...state.cart, deliveryAddress: payload }
  },
  SET_BILLING_ADDRESS(state, payload) {
    state.billingAddress = payload
    state.cart = { ...state.cart, billingAddress: payload }
  },
  SET_CUSTOMER(state, payload) {
    state.customer = payload
    payload && localStorage.setItem("customer", JSON.stringify(payload))
    this.$posthog.identify(payload.email)
  },
  SET_USER(state, payload) {
    state.user = payload
    this.$posthog.identify(payload.email)
  },
  SET_DISCOUNT_LOADING(state, payload) {
    state.discountLoading = payload
  },
  SET_DISCOUNT_ERROR(state, payload) {
    state.discountError = payload
  },
  SET_CHOSEN_DISCOUNT(state, payload) {
    state.discount = payload
  },
  SET_CHOSEN_DEAL(state, payload) {
    state.chosenDeal = payload
  },
  SET_REWARDS(state, payload) {
    state.rewards = payload
  },
  SET_REWARD_SELECTED(state, payload) {
    state.rewardSelected = payload
  },
  SET_ORDERS(state, payload) {
    state.orders = payload
      ? payload.filter(
          (order) =>
            order.status !== "Cancelled" &&
            !(order.paid === "Unpaid" && order.status === "Created")
        )
      : false
  },
  SET_CHOSEN_ORDER(state, payload) {
    state.chosenOrder = payload
  },
  SET_REVIEWS(state, payload) {
    state.reviews = payload
  },
  SET_REVIEW_MESSAGE(state, payload) {
    state.reviewMessage = payload
  },
  SET_MAKERS(state, payload) {
    state.makers = payload
      .filter((maker) => {
        const isActive = maker.is_active
        const hasBizCategory = maker.makersCategories.some((cat) => cat.biz)
        const emailCheck =
          !state.isProduction || !maker.email.includes("anddine")

        return isActive && hasBizCategory && emailCheck
      })
      .map((maker) => createDeliveryDays(maker, state.cart))
  },
  SET_CHOSEN_MAKER(state, payload) {
    state.chosenMaker = createDeliveryDays(payload, state.cart)
  },
  SET_MAKER_CATEGORIES(state, payload) {
    const randomCategories = payload
      .map((category) => ({
        ...category,
        makers: category.makers
          .filter((maker) => {
            const isActive = maker.is_active
            const emailCheck =
              !state.isProduction || !maker.email.includes("anddine")
            return isActive && emailCheck
          })
          .sort(() => 0.5 - Math.random()),
      }))
      .filter((category) => category.biz && category.makers.length > 0)
      .sort(() => 0.5 - Math.random())

    state.makerCategories = randomCategories
  },

  SET_CHOSEN_MAKER_CATEGORY(state, payload) {
    state.chosenMakerCategory = payload[0]
  },
  SET_FILTERED_MAKERS(state, payload) {
    state.filteredMakers = payload
      ? payload
          .map((maker) => createDeliveryDays(maker, state.cart))
          .filter((maker) => maker.makersCategories.some((cat) => cat.biz))
      : payload
  },
  SET_CART_LOADING(state, payload) {
    state.cartLoading = payload
  },
  SET_ACCOUNT_LOADING(state, payload) {
    state.accountLoading = payload
  },
  SET_CART(state, payload) {
    if (payload) {
      state.cart = {
        ...payload,
        date: payload?.date || false,
      }
      state.cartError = payload.date?.selectedWindow
        ? false
        : "Please select a date and time"
      localStorage.setItem("and-dine-cart", JSON.stringify(state.cart))
    } else {
      state.cart = false
      localStorage.setItem("and-dine-cart", false)
    }
  },
  SET_RESET_CONFIRMATION(state, payload) {
    state.resetConfirmation = payload
  },
  SET_CHECKOUT_ERROR(state, payload) {
    state.checkoutError = payload
  },
  SET_CART_ERROR(state, payload) {
    state.cartError = payload
  },
  SET_NEW_VERIFICATION_SUCCESS(state, payload) {
    state.newVerificationSuccess = payload
  },
  SET_VERIFICATION_LOADING(state, payload) {
    state.verificationLoading = payload
  },
  SET_NEW_VERIFICATION_ERROR(state, payload) {
    state.newVerificationError = payload
  },
  SET_RESET_PASSWORD_ERROR(state, payload) {
    state.resetPasswordError = payload
  },
  SET_RESET_PASSWORD_SUCCESS(state, payload) {
    state.resetPasswordSuccess = payload
  },
  SET_CUSTOMER_LOADING(state, payload) {
    state.customerLoading = payload
  },
  SET_WINDOW_SIZE(state, payload) {
    state.windowSize = payload
  },
  SET_ORGANISATION_LOADING(state, payload) {
    state.organisationLoading = payload
  },
  SET_ORGANISATION(state, payload) {
    state.organisation = payload
  },
  SET_ORGANISATION_ORDERS(state, payload) {
    state.organisationOrders = payload
  },
  SET_ORGANISATION_ORDER_PRODUCTS(state, payload) {
    state.organisationOrderProducts = payload
  },
  SET_DEAL_ID(state, payload) {
    state.dealId = payload
  },
  SET_PAYMENT_LOADING(state, payload) {
    state.paymentLoading = payload
  },
  SET_PURCHASE_ORDER_LOADING(state, payload) {
    state.purchaseOrderLoading = payload
  },
  SET_PURCHASE_ORDER_ERROR(state, payload) {
    state.purchaseOrderError = payload
  },
  SET_ORG_PACKAGE_CHOICES(state, payload) {
    state.orgPackageChoices = payload
  },
  SET_SUBSCRIPTION_TYPES(state, payload) {
    state.subscriptionTypes = payload
  },
  SET_PACKAGE_TYPES(state, payload) {
    if (state.isProduction) {
      state.packageTypes = payload.filter(
        (result) => !state.testMakers.includes(result.maker_id)
      )
    } else {
      state.packageTypes = payload
    }
  },
  SET_DEFAULT_PACKAGE_CHOICES(state, payload) {
    state.defaultPackageChoices = payload
  },
  SET_UPDATE_PRODUCTS_LOADING(state, payload) {
    state.updateProductsLoading = payload
  },
  SET_UPDATE_PRODUCTS_ERROR(state, payload) {
    state.updateProductsError = payload
  },
  SET_CANCEL_DAILY_LOADING(state, payload) {
    state.cancelDailyOrderLoading = payload
  },
  SET_CANCEL_DAILY_ERROR(state, payload) {
    state.cancelDailyOrderError = payload
  },
  SET_PREMIUM_CUT_OFF_DAY(state, payload) {
    state.premiumCutOffDay = payload
  },
  SET_APPEND_PRODUCTS_LOADING(state, payload) {
    state.appendProductsLoading = payload
  },
  SET_APPEND_PRODUCTS_ERROR(state, payload) {
    state.appendProductsError = payload
  },
}

export const actions = {
  clearCart({ commit }) {
    commit("SET_CART", false)
    commit("SET_ORDER", false)
    commit("SET_CART_LOADING", false)
  },
  clearOrder({ commit }, id) {
    localStorage.removeItem(id)
  },
  async googleAuth({ commit, dispatch }, payload) {
    await this.$axios
      .post(`${process.env.AND_DINE_API}/api/auth/google`, payload.token)
      .then((response) => {
        commit("SET_AUTHENTICATED", response.data)
        if (response.data.subscription) {
          payload.redirect = "/account/premium"
        }
        dispatch("getCustomer", payload.redirect)
      })
      .catch((error) => {
        commit(
          "SET_LOGIN_ERROR",
          `${error.response.data} - Please try again or try logging in using another method`
        )
        commit("SET_AUTHENTICATED", false)
        this.$sentry.captureException(error)
      })
  },
  async getTags({ commit, dispatch }) {
    await this.$axios
      .get(
        `${process.env.AND_DINE_API}/api/public/tags?limit=9999&filter=[{"key":"is_linked","value":1},{"key":"is_active","value":1}]`
      )
      .then((response) => {
        commit("SET_TAGS", response.data.tags)
        dispatch("getAllergens")
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async getAllergens({ commit, dispatch }) {
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/public/allergens`)
      .then((response) => {
        commit("SET_ALLERGENS", response.data.allergens)
        dispatch("getCuisines")
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async getCuisines({ commit }) {
    await this.$axios
      .get(
        `${process.env.AND_DINE_API}/api/public/cuisines?limit=9999&filter=[{"key":"is_linked","value":1},{"key":"is_active","value":1}]`
      )
      .then((response) => {
        commit("SET_CUISINES", response.data.models)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  deepSearch: debounce(async function ({ commit, state }, search) {
    await this.$axios
      .get(
        `${process.env.AND_DINE_API}/api/public/makers/deepSearch?searchName=${search}&is_biz=true`
      )
      .then((response) => {
        commit("SET_SEARCH_RESULTS", response.data)
      })
      .catch((error) => {
        commit("SET_SEARCH_RESULTS", false)
        this.$sentry.captureException(error)
      })
  }, 400),
  async deepFilter({ commit }, payload) {
    const tags = payload?.tags
      ? `&tags=${JSON.stringify(payload.tags.map((tag) => tag.id))}`
      : false
    const cuisines = payload?.cuisines
      ? `&cuisines=${JSON.stringify(
          payload.cuisines.map((cuisine) => cuisine.id)
        )}`
      : false
    const query = {}
    if (payload.tags) {
      query.tags = JSON.stringify(payload.tags.map((tag) => tag.id))
    }
    if (payload.cuisines) {
      query.cuisines = JSON.stringify(
        payload.cuisines.map((cuisine) => cuisine.id)
      )
    }
    if (Object.keys(query).length > 0) {
      this.$router.push({ query })
    }
    if (tags || cuisines) {
      await this.$axios
        .get(
          `${
            process.env.AND_DINE_API
          }/api/public/makers/deepFilter?is_active=1${tags || ""}${
            cuisines || ""
          }`
        )
        .then((response) => {
          commit("SET_FILTERED_MAKERS", response.data)
        })
        .catch((error) => {
          this.$sentry.captureException(error)
        })
    } else {
      commit("SET_FILTERED_MAKERS", false)
    }
  },
  getMakers: debounce(async function ({ commit, dispatch }, payload) {
    commit("SET_MAKERS_LOADING", true)
    const filters = payload?.filters || []
    const filterQuery = generateFilterQuery(filters)
    const page = payload?.page || 1
    const limit = payload?.limit || 999
    const query = `?limit=${limit}&page=${page}${filterQuery}`
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/public/makers${query}`)
      .then((response) => {
        commit("SET_MAKERS_LOADING", false)
        commit("SET_MAKERS", response.data.models)
        dispatch("getTags")
      })
      .catch((error) => {
        this.$sentry.captureException(error)
        commit("SET_MAKERS_LOADING", false)
      })
  }),
  async getMakerCategories({ commit, state }) {
    commit("SET_MAKER_CATEGORIES_LOADING", true)
    await this.$axios
      .get(
        `${process.env.AND_DINE_API}/api/public/makerCategories?limit=9999&filter=[{"key":"is_active","value":1},{"key":"biz","value":1}]`
      )
      .then((response) => {
        commit("SET_MAKER_CATEGORIES", response.data.models)
        commit("SET_MAKER_CATEGORIES_LOADING", false)
      })
      .catch((error) => {
        commit("SET_MAKER_CATEGORIES_LOADING", false)
        this.$sentry.captureException(error)
        this.$router.push("/404")
      })
  },
  async getMakerCategory({ commit }, name) {
    await this.$axios
      .get(
        `${process.env.AND_DINE_API}/api/public/makerCategories/search?name=${name}&is_active=1`
      )
      .then((response) => {
        commit("SET_CHOSEN_MAKER_CATEGORY", response.data.models)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async getMakerBySlug({ commit }, payload) {
    commit("SET_MAKER_LOADING", true)
    await this.$axios
      .get(
        `${process.env.AND_DINE_API}/api/public/makers/slugs/${payload.slug}`
      )
      .then((response) => {
        if (!response.data.is_active && payload.makerPage) {
          this.$router.push("/")
        }
        commit("SET_CHOSEN_MAKER", response.data)
        commit("SET_PRODUCT_CATEGORIES", response.data.productCategories)
        commit("SET_MAKER_LOADING", false)
      })
      .catch((error) => {
        commit("SET_MAKER_LOADING", false)
        this.$sentry.captureException(error)
        this.$router.push("/404")
      })
  },
  async getMakerById({ commit }, id) {
    commit("SET_MAKER_LOADING", true)
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/public/makers/${id}`)
      .then((response) => {
        commit("SET_CHOSEN_MAKER", response.data)
        commit("SET_PRODUCT_CATEGORIES", response.data.productCategories)
        commit("SET_MAKER_LOADING", false)
      })
      .catch((error) => {
        commit("SET_MAKER_LOADING", false)
        this.$sentry.captureException(error)
      })
  },
  async searchMakers({ commit }, slug) {
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/public/makers/search?slug=${slug}`)
      .then((response) => {
        commit("SET_CHOSEN_MAKER", response.data)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async getPackages({ commit }) {
    commit("SET_PACKAGES_LOADING", true)
    await this.$axios
      .get(
        `${process.env.AND_DINE_API}/api/public/packages/?limit=999&is_active=1`
      )
      .then((response) => {
        commit("SET_PACKAGES", response.data.packages)
        commit("SET_PACKAGES_LOADING", false)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
        commit("SET_PACKAGES_LOADING", false)
      })
  },
  async getPackageById({ commit }, id) {
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/public/packages/${id}`)
      .then((response) => {
        commit("SET_CHOSEN_PACKAGE", response.data)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async getProductsByMaker({ commit }, id) {
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/public/products/maker/${id}`)
      .then((response) => {
        commit("SET_BUNDLES", response.data.products)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async getProductById({ commit }, id) {
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/public/products/${id}`)
      .then((response) => {
        commit("SET_CHOSEN_PRODUCT", response.data)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async getProductBySlug({ commit }, slug) {
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/public/products/slugs/${slug}`)
      .then((response) => {
        commit("SET_CHOSEN_PRODUCT", response.data)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async getDealById({ commit }, id) {
    const config = {
      headers: {
        accept: "application/json",
        Authorization: `Bearer ${process.env.HUBSPOT_TOKEN}`,
        "content-type": "application/json",
      },
    }
    await this.$axios
      .get(`${process.env.HUBSPOT_API}/deals/${id}`, config)
      .then((response) => {
        commit("SET_CHOSEN_DEAL", response.data)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async createCustomer({ commit }, payload) {
    await this.$axios
      .post(
        `${process.env.AND_DINE_API}/api/public/customers/register`,
        payload
      )
      .then(() => {
        commit("SET_SIGN_UP_SUCCESS", true)
        commit("SET_SIGN_UP_ERROR", false)
      })
      .catch((error) => {
        commit("SET_SIGN_UP_SUCCESS", false)
        commit("SET_SIGN_UP_ERROR", error.response.data)
        commit("SET_AUTHENTICATED", false)
        this.$sentry.captureException(error)
      })
  },
  customerLogout({ commit }, redirect) {
    commit("SET_USER", false)
    commit("SET_ORDERS", false)
    commit("SET_REWARDS", false)
    commit("SET_AUTHENTICATED", false)
    redirect && this.$router.push(redirect)
  },
  async verifyCustomer({ commit }, payload) {
    await this.$axios
      .put(
        `${process.env.AND_DINE_API}/api/public/customers/verify/${payload.verificationId}`
      )
      .then(() => {
        commit("SET_VERIFY_SUCCESS", true)
        commit("SET_VERIFY_ERROR", false)
      })
      .catch((error) => {
        commit("SET_VERIFY_SUCCESS", false)
        commit("SET_VERIFY_ERROR", error.response.data)
        this.$sentry.captureException(error)
      })
  },
  async generateNewVerification({ commit }, payload) {
    await this.$axios
      .post(
        `${process.env.AND_DINE_API}/api/public/customers/verify/resend`,
        payload
      )
      .then(() => {
        commit("SET_NEW_VERIFICATION_SUCCESS", true)
        commit("SET_NEW_VERIFICATION_ERROR", false)
        commit("SET_VERIFICATION_LOADING", false)
      })
      .catch((error) => {
        commit("SET_NEW_VERIFICATION_SUCCESS", false)
        commit("SET_NEW_VERIFICATION_ERROR", error.response.data)
        commit("SET_VERIFICATION_LOADING", false)
        this.$sentry.captureException(error)
      })
  },
  async forgotPassword({ commit }, payload) {
    await this.$axios
      .post(
        `${process.env.AND_DINE_API}/api/public/customers/forgotPassword`,
        payload
      )
      .then(() => {
        commit("SET_RESET_CONFIRMATION", true)
      })
      .catch((error) => {
        commit("SET_RESET_CONFIRMATION", false)
        commit("SET_SIGN_UP_ERROR", error.response.data)
      })
  },
  async resetCustomerPassword({ commit }, payload) {
    commit("SET_CUSTOMER_LOADING", true)
    await this.$axios
      .put(
        `${process.env.AND_DINE_API}/api/public/customers/resetPassword`,
        payload
      )
      .then(() => {
        commit("SET_CUSTOMER_LOADING", false)
        commit("SET_RESET_PASSWORD_SUCCESS", true)
        commit("SET_RESET_PASSWORD_ERROR", false)
      })
      .catch((error) => {
        commit("SET_CUSTOMER_LOADING", false)
        commit("SET_RESET_PASSWORD_SUCCESS", false)
        commit("SET_RESET_PASSWORD_ERROR", error.response.data)
      })
  },
  async customerLogin({ commit, dispatch }, payload) {
    commit("SET_AUTH_LOADING", true)
    await this.$axios
      .post(
        `${process.env.AND_DINE_API}/api/public/customers/login`,
        payload.credentials
      )
      .then((response) => {
        commit("SET_AUTHENTICATED", response.data)
        if (response.data.subscription && !payload.redirect) {
          payload.redirect = "/account/premium"
        }
        dispatch("getCustomer", payload.redirect)
      })
      .catch((error) => {
        commit("SET_LOGIN_ERROR", error.response.data)
        commit("SET_AUTHENTICATED", false)
        commit("SET_AUTH_LOADING", false)
        this.$sentry.captureException(error)
      })
  },
  async getCustomer({ commit, state, dispatch }, redirect) {
    commit("SET_ACCOUNT_LOADING", true)
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/customers/profile`, config)
      .then((response) => {
        commit("SET_USER", response.data)
        commit("SET_LOGIN_ERROR", false)
        commit("SET_AUTH_LOADING", false)
        commit("SET_ACCOUNT_LOADING", false)
        redirect && this.$router.push(redirect)
      })
      .catch((error) => {
        commit("SET_AUTHENTICATED", false)
        commit("SET_AUTH_LOADING", false)
        commit("SET_ACCOUNT_LOADING", false)
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
      })
  },
  async updateCustomer({ commit, state, dispatch }, payload) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    await this.$axios
      .put(`${process.env.AND_DINE_API}/api/customers`, payload, config)
      .then(() => {
        commit("SET_SIGN_UP_ERROR", false)
        dispatch("getCustomer", "/account/details")
      })
      .catch((error) => {
        commit("SET_SIGN_UP_ERROR", error.response.data)
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
      })
  },
  async getRewards({ commit, state, dispatch }) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/customers/rewards`, config)
      .then((response) => {
        commit("SET_REWARDS", response.data)
      })
      .catch((error) => {
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
      })
  },
  async addDiscount({ commit, state }, payload) {
    commit("SET_DISCOUNT_LOADING", true)
    commit("SET_DISCOUNT_ERROR", false)
    const body = { discount_code: payload.discount_code }
    await this.$axios
      .put(
        `${process.env.AND_DINE_API}/api/public/orders/applyDiscount/${payload.id}`,
        body
      )
      .then((response) => {
        commit("SET_DISCOUNT_LOADING", false)
        commit("SET_CHOSEN_DISCOUNT", {
          ...response.data.dataValues,
          discount_code: payload.discount_code,
        })
        commit("SET_ORDER", {
          ...response.data.dataValues,
          paymentIntent: response.data.paymentIntent,
          maker: state.order.maker,
          orderProducts: state.order.orderProducts,
        })
      })
      .catch((error) => {
        commit("SET_DISCOUNT_LOADING", false)
        commit("SET_DISCOUNT_ERROR", "Discount code not valid")
        this.$sentry.captureException(error)
      })
  },
  async addReward({ commit, state, dispatch }, payload) {
    commit("SET_DISCOUNT_LOADING", true)
    commit("SET_DISCOUNT_ERROR", false)
    const body = { reward_id: payload.reward_id }
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    await this.$axios
      .put(
        `${process.env.AND_DINE_API}/api/customers/orders/applyReward/${payload.id}`,
        body,
        config
      )
      .then((response) => {
        commit("SET_DISCOUNT_LOADING", false)
        commit("SET_REWARD_SELECTED", {
          ...response.data.dataValues,
          discount_code: payload.discount_code,
        })
        commit("SET_ORDER", {
          ...response.data.dataValues,
          paymentIntent: response.data.paymentIntent,
          maker: state.order.maker,
          orderProducts: state.order.orderProducts,
        })
      })
      .catch((error) => {
        commit("SET_DISCOUNT_LOADING", false)
        commit("SET_DISCOUNT_ERROR", "Reward not valid")
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
      })
  },
  async addBundleToCart({ commit, state, dispatch }, payload) {
    let updatedItems = state.cart?.items || []
    const makerId = payload?.maker?.id || state.cart?.maker?.id
    payload.bundle.forEach((bundle) => {
      const index = updatedItems.findIndex(
        (item) =>
          item.product.id === bundle.product.id &&
          item.appliedModifiers.every(
            (modifier, index) =>
              modifier.modifier_id ===
              bundle.appliedModifiers[index].modifier_id
          )
      )
      if (index === -1) {
        updatedItems = [
          ...updatedItems,
          {
            product: bundle.product,
            quantity: bundle.quantity,
            appliedModifiers: bundle.appliedModifiers,
          },
        ]
      } else {
        updatedItems = [
          ...updatedItems.slice(0, index),
          {
            product: bundle.product,
            quantity: bundle.quantity,
            appliedModifiers: bundle.appliedModifiers,
          },
          ...updatedItems.slice(index + 1),
        ].filter((item) => item.quantity > 0)
      }
    })
    const body = {
      items: updatedItems.map((item) => {
        return {
          id: item.product.id,
          name: item.product.name,
          quantity: item.quantity,
          appliedModifiers: item.appliedModifiers,
        }
      }),
      maker_id: makerId,
    }
    await this.$axios
      .post(`${process.env.AND_DINE_API}/api/public/orders/cart`, body)
      .then((response) => {
        const newCart = {
          ...response.data,
          maker: {
            id: payload.maker.id,
            name: payload.maker.name,
            slug: payload.maker.slug,
            address: payload.maker.address,
            delivery_days: payload.maker.delivery_days,
            next_available: payload.maker.next_available,
            free_delivery_min_amount: payload.maker.free_delivery_min_amount,
            min_order_amount: payload.maker.min_order_amount || 1500,
          },
          date: payload.date || false,
          items: updatedItems.map((item) => {
            return {
              product: {
                id: item.product.id,
                name: item.product.name,
                attachments: item.product.attachments,
                same_day: item.product.same_day,
                future_day: item.product.future_day,
                min_order_amount: item.product.min_order_amount,
                price: item.product.price,
              },
              quantity: item.quantity,
              appliedModifiers: item.appliedModifiers,
            }
          }),
        }
        commit("SET_CART_LOADING", false)
        commit("SET_CART", newCart)
        newCart.date && commit("SET_DELIVERY_WINDOWS", newCart.date)
        state.deliveryAddress && dispatch("createOrder")
      })
      .catch((error) => {
        commit("SET_CART_LOADING", false)
        this.$sentry.captureException(error)
      })
    state.isProduction &&
      this.$gtm.push({
        event: "add_to_cart",
        ...{
          currency: "GBP",
          value: state.cart.total,
          items: updatedItems.map((item) => {
            return {
              item_id: item.id,
              item_name: item.name,
              item_brand: state.chosenMaker.name,
              item_category:
                state.productCategories &&
                state.productCategories.length &&
                state.productCategories.find(
                  (category) => category.id === item.categoryId
                )?.name,
              price: item.price,
              quantity: item.quantity,
            }
          }),
        },
      })
  },
  addToCart: debounce(async function ({ commit, state, dispatch }, payload) {
    let updatedItems = state.cart?.items || payload.items || []
    const makerId = payload?.maker?.id || state.cart?.maker?.id
    if (payload.product) {
      const index = updatedItems.findIndex(
        (item) =>
          item.product.id === payload.product.id &&
          item.appliedModifiers.every(
            (modifier, index) =>
              modifier.modifier_id ===
              payload.appliedModifiers[index].modifier_id
          )
      )
      if (index === -1) {
        updatedItems = [
          ...updatedItems,
          {
            product: payload.product,
            quantity: payload.quantity,
            appliedModifiers: payload.appliedModifiers,
          },
        ]
      } else {
        updatedItems = [
          ...updatedItems.slice(0, index),
          {
            product: payload.product,
            quantity: payload.quantity,
            appliedModifiers: payload.appliedModifiers,
          },
          ...updatedItems.slice(index + 1),
        ].filter((item) => item.quantity > 0)
      }
    }
    const body = {
      items: updatedItems.map((item) => {
        return {
          id: item.product.id,
          name: item.product.name,
          quantity: item.quantity,
          appliedModifiers: item.appliedModifiers,
        }
      }),
      maker_id: makerId,
    }
    await this.$axios
      .post(`${process.env.AND_DINE_API}/api/public/orders/cart`, body)
      .then((response) => {
        const newCart = {
          ...response.data,
          deal_id: payload.deal_id || null,
          maker: {
            id: payload.maker.id,
            name: payload.maker.name,
            slug: payload.maker.slug,
            address: payload.maker.address,
            delivery_days: payload.maker.delivery_days,
            next_available: payload.maker.next_available,
            free_delivery_min_amount: payload.maker.free_delivery_min_amount,
            min_order_amount: payload.maker?.min_order_amount || 1500,
          },
          date: payload.date || false,
          items: updatedItems.map((item) => {
            return {
              product: {
                id: item.product.id,
                name: item.product.name,
                attachments: item.product.attachments,
                same_day: item.product.same_day,
                future_day: item.product.future_day,
                min_order_amount: item.product.min_order_amount,
                price: item.product.price,
                vat_price:
                  parseFloat(item.product.price) *
                  (1 + parseFloat(item.product.vat_level) / 100),
              },
              quantity: item.quantity,
              appliedModifiers: item.appliedModifiers,
            }
          }),
        }
        this.$posthog.capture("product_added", {
          product: newCart,
        })
        commit("SET_CART_LOADING", false)
        commit("SET_CART", newCart)
        newCart.date && commit("SET_DELIVERY_WINDOWS", newCart.date)
        dispatch("validateOrder", newCart)
      })
      .catch((error) => {
        commit("SET_CART_LOADING", false)
        this.$sentry.captureException(error)
      })
    state.isProduction &&
      this.$gtm.push({
        event: "add_to_cart",
        ...{
          currency: "GBP",
          value: state.cart.total,
          items: updatedItems.map((item) => {
            return {
              item_id: item.id,
              item_name: item.name,
              item_brand: state.chosenMaker.name,
              item_category:
                state.productCategories &&
                state.productCategories.length &&
                state.productCategories.find(
                  (category) => category.id === item.categoryId
                )?.name,
              price: item.price,
              quantity: item.quantity,
            }
          }),
        },
      })
  }, 100),
  removeFromCart: debounce(async function (
    { commit, state, dispatch },
    payload
  ) {
    let updatedItems = state.cart.items
    const index = updatedItems.findIndex(
      (item) =>
        item.product.id === payload.product.id &&
        item.appliedModifiers.every(
          (modifier, index) =>
            modifier.id === payload.appliedModifiers[index].id
        )
    )
    if (index === -1) {
      return
    }
    updatedItems = [
      ...updatedItems.slice(0, index),
      {
        product: payload.product,
        quantity: payload.quantity,
        appliedModifiers: payload.appliedModifiers,
      },
      ...updatedItems.slice(index + 1),
    ].filter((item) => item.quantity > 0)

    if (updatedItems.length === 0) {
      dispatch("clearCart")
    } else {
      commit("SET_CART_LOADING", true)
      const body = {
        items: updatedItems.map((item) => {
          return {
            id: item.product.id,
            name: item.product.name,
            quantity: item.quantity,
            appliedModifiers: item.appliedModifiers,
          }
        }),
        maker_id: payload.maker.id,
      }

      await this.$axios
        .post(`${process.env.AND_DINE_API}/api/public/orders/cart`, body)
        .then((response) => {
          const newCart = {
            ...response.data,
            maker: {
              id: payload.maker.id,
              name: payload.maker.name,
              slug: payload.maker.slug,
              address: payload.maker.address,
              delivery_days: payload.maker.delivery_days,
              next_available: payload.maker.next_available,
              free_delivery_min_amount: payload.maker.free_delivery_min_amount,
              min_order_amount: payload.maker?.min_order_amount || 1500,
            },
            date: payload?.date || false,
            items: updatedItems.map((item) => {
              return {
                product: {
                  id: item.product.id,
                  name: item.product.name,
                  attachments: item.product.attachments,
                  same_day: item.product.same_day,
                  future_day: item.product.future_day,
                  min_order_amount: item.product.min_order_amount,
                  price: item.product.price,
                },
                quantity: item.quantity,
                appliedModifiers: item.appliedModifiers,
              }
            }),
          }
          commit("SET_CART_LOADING", false)
          commit("SET_CART", newCart)
          dispatch("validateOrder", newCart)
        })
        .catch((error) => {
          commit("SET_CART_LOADING", false)
          this.$sentry.captureException(error)
        })
      state.isProduction &&
        this.$gtm.push({
          event: "remove_from_cart",
          ...{
            currency: "GBP",
            value: state.cart.total,
            items: updatedItems.map((item) => {
              return {
                item_id: item.id,
                item_name: item.name,
                item_brand: state.chosenMaker.name,
                item_category:
                  state.productCategories &&
                  state.productCategories.length &&
                  state.productCategories.find(
                    (category) => category.id === item.categoryId
                  )?.name,
                price: item.price,
                quantity: item.quantity,
              }
            }),
          },
        })
    }
  },
  100),
  createShareCart({ state }, id) {
    const cartString = JSON.stringify({
      ...state.cart,
      deal_id: id || null,
    })
    return this.$axios.post(
      `${process.env.AND_DINE_API}/api/public/shareCart`,
      {
        cart: cartString,
        customer_id: null,
      },
      {}
    )
  },
  getShareCart({ dispatch }, id) {
    dispatch("clearCart")
    return this.$axios.get(
      `${process.env.AND_DINE_API}/api/public/shareCart/${id}`,
      {}
    )
  },
  validateOrder: debounce(async function ({ commit, state }, payload) {
    const belowAmount =
      (state.cart.maker.min_order_amount / 100 || 15) >
      parseFloat(state.cart.totalVatFree / 100).toFixed(2)

    commit("SET_CHECKOUT_ERROR", false)

    if (state.deliveryAddress?.formatted?.zip) {
      const isValid = true
      if (!isValid) {
        commit(
          "SET_CHECKOUT_ERROR",
          "Sorry, we don't deliver to your postal code"
        )
        commit("SET_ORDER", false)
        commit("SET_CART_LOADING", false)
        return
      }
    }

    if (belowAmount || state.cartError) {
      commit("SET_ORDER", false)
    } else {
      commit("SET_CART_LOADING", true)
      const items = payload.items.map((item) => {
        return {
          id: item.product.id,
          name: item.product.name,
          quantity: item.quantity,
          appliedModifiers: item.appliedModifiers,
          itemPrice: item.product.price,
        }
      })

      const body = {
        items,
        same_day: false,
        deal_id: payload.deal_id || null,
        biz: true,
        customer_first_name: state.customer.first_name,
        customer_last_name: state.customer.last_name,
        delivery_date_time: `${payload.date.full}T${payload.date.selectedWindow}:00Z`,
        maker_id: payload.maker.id,
        discount_id: null,
        customer_phone: state.customer.phone,
        customer_email: state.customer.email,
        note: payload.orderNotes || "",
        delivery_note: payload.deliveryNotes || "",
        delivery_address: {
          zip: state.deliveryAddress.formatted?.zip,
          city: state.deliveryAddress.formatted?.city,
          line_1: state.deliveryAddress.formatted?.line_1,
          line_2: state.deliveryAddress.formatted?.line_2,
        },
        pick_up_address: {
          zip: payload.maker.address?.zip,
          city: payload.maker.address?.city,
          line_1: payload.maker.address?.line_1,
          line_2: payload.maker.address?.line_2,
        },
        billing_address: {
          zip: state.billingAddress?.formatted?.zip,
          city: state.billingAddress?.formatted?.city,
          line_1: state.billingAddress?.formatted?.line_1,
          line_2: state.billingAddress?.formatted?.line_2,
        },
        business_name: state.customer?.business_name,
        delivery_service: "Onfleet",
        organisation_id: state.organisation ? state.organisation.id : null,
      }

      const config = state.authenticated
        ? {
            headers: {
              accept: "application/json",
              "x-access-token-customer": state.authenticated.token,
              "content-type": "application/json",
            },
          }
        : {}

      await this.$axios
        .put(
          state.authenticated
            ? `${process.env.AND_DINE_API}/api/customers/orders/validate`
            : `${process.env.AND_DINE_API}/api/public/orders/validate`,
          body,
          config
        )
        .then((response) => {
          commit("SET_CART_LOADING", false)
          commit("SET_CHECKOUT_ERROR", false)
          commit("SET_ORDER", response.data)
          commit("SET_REWARDS", response.data.rewards)
          state.isProduction &&
            this.$gtm.push({
              event: "begin_checkout",
              ...{
                currency: "GBP",
                value: payload.subtotal,
                items: payload.items
                  .filter((item) => item.quantity > 0)
                  .map((item) => {
                    return {
                      item_id: item.product.sku,
                      item_name: item.product.name,
                      item_brand: payload.maker.name,
                      item_category:
                        state.productCategories &&
                        state.productCategories.length &&
                        state.productCategories.find(
                          (category) => category.id === item.product.category_id
                        )?.name,
                      price: item.product.price,
                      quantity: item.quantity,
                    }
                  }),
              },
            })
        })
        .catch((error) => {
          commit("SET_CART_LOADING", false)
          commit(
            "SET_CHECKOUT_ERROR",
            error.response ? error.response.data : error.message
          )
          commit("SET_ORDER", false)
        })
    }
  }, 400),
  async createOrder({ commit, state, dispatch }, payload) {
    commit("SET_CART_LOADING", true)
    commit("SET_CHECKOUT_ERROR", false)
    const items = payload.items.map((item) => {
      return {
        id: item.product.id,
        name: item.product.name,
        quantity: item.quantity,
        appliedModifiers: item.appliedModifiers,
        itemPrice: item.product.price,
      }
    })

    const body = { items, ...state.order, deal_id: payload.deal_id || null }
    const config = state.authenticated
      ? {
          headers: {
            accept: "application/json",
            "x-access-token-customer": state.authenticated.token,
            "content-type": "application/json",
          },
        }
      : {}

    await this.$axios
      .post(
        state.authenticated
          ? `${process.env.AND_DINE_API}/api/customers/orders`
          : `${process.env.AND_DINE_API}/api/public/orders`,
        body,
        config
      )
      .then((response) => {
        commit("SET_CART_LOADING", false)
        commit("SET_CHECKOUT_ERROR", false)
        commit("SET_ORDER", response.data)
        commit("SET_REWARDS", response.data.rewards)
        state.isProduction &&
          this.$gtm.push({
            event: "begin_checkout",
            ...{
              currency: "GBP",
              value: payload.subtotal,
              items: payload.items
                .filter((item) => item.quantity > 0)
                .map((item) => {
                  return {
                    item_id: item.product.sku,
                    item_name: item.product.name,
                    item_brand: payload.maker.name,
                    item_category:
                      state.productCategories &&
                      state.productCategories.length &&
                      state.productCategories.find(
                        (category) => category.id === item.product.category_id
                      )?.name,
                    price: item.product.price,
                    quantity: item.quantity,
                  }
                }),
            },
          })
      })
      .catch((error) => {
        commit("SET_CART_LOADING", false)
        commit("SET_ORDER", false)
        commit(
          "SET_CHECKOUT_ERROR",
          error.response ? error.response.data : error.message
        )
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
      })
  },
  async createDailyOrder({ commit, state, dispatch }, payload) {
    commit("SET_CART_LOADING", true)
    commit("SET_CHECKOUT_ERROR", false)
    try {
      const items = payload.cart.items.map((item) => ({
        id: item.product.id,
        name: item.product.name,
        quantity: item.quantity,
        appliedModifiers: item.appliedModifiers,
        itemPrice: item.product.price,
      }))

      const deliveryAddress =
        state.organisation.subscription.delivery_address ||
        state.organisation.delivery_address

      const body = {
        packages: [
          {
            id: state.chosenPackage.id,
            name: state.chosenPackage.name,
            package: {
              ...state.chosenPackage,
              quantity: payload.packageQuantity,
            },
            package_type_id: payload.chosenPackageTypeId,
            quantity: payload.packageQuantity,
          },
        ],
        maker_id: state.chosenMaker.id,
        customer_first_name: state.user.first_name,
        customer_last_name: state.user.last_name,
        customer_email: state.user.email,
        customer_phone: state.user.phone || state.organisation.telephone,
        business_name: state.organisation.name || state.user.business_name,
        maker_email: state.chosenMaker.email,
        maker_phone: state.chosenMaker.phone,
        delivery_note: state.organisation.delivery_note,
        note: payload.orderNote,
        biz: true,
        delivery_address: deliveryAddress,
        pick_up_address: state.chosenMaker.address,
        billing_address: state.organisation.billing_address || deliveryAddress,
        delivery_date_time: `${payload.cart.date.chosenDate.full}T${payload.cart.date.selectedWindow}:00Z`,
        items,
        deal_id: payload.cart.deal_id || null,
      }

      const config = state.authenticated
        ? {
            headers: {
              accept: "application/json",
              "x-access-token-customer": state.authenticated.token,
              "content-type": "application/json",
            },
          }
        : {}

      const response = await this.$axios.post(
        `${process.env.AND_DINE_API}/api/customers/orders/daily`,
        body,
        config
      )
      commit("SET_CART_LOADING", false)
      commit("SET_CHECKOUT_ERROR", false)
      commit("SET_ORDER", response.data)
      commit("SET_REWARDS", response.data.rewards)
      await dispatch("getOrders", true)
    } catch (error) {
      commit(
        "SET_CHECKOUT_ERROR",
        error.response ? error.response.data : error.message
      )
      commit("SET_CART_LOADING", false)
      commit("SET_ORDER", false)

      if (error.response?.data === "Invalid Token") {
        dispatch("customerLogout")
      }

      this.$sentry.captureException(error)
    }
  },
  async updateOrderDelivery({ commit, dispatch }, payload) {
    const { id } = payload
    await this.$axios
      .put(
        `${process.env.AND_DINE_API}/api/public/orders/updateDelivery/${id}`,
        payload
      )
      .catch((error) => {
        commit("SET_CHECKOUT_ERROR", error.response.data)
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
      })
  },
  async stripePayment({ commit, state, dispatch }, payload) {
    commit("SET_CART_LOADING", true)
    commit("SET_CHECKOUT_ERROR", false)
    await payload.elements.submit()
    await this.$stripe
      .confirmPayment({
        elements: payload.elements,
        clientSecret: payload.elements.clientSecret,
        handle_card_payment: false,
        redirect: "if_required",
        confirmParams: {
          payment_method_data: {
            billing_details: {
              name: `${state.customer.first_name} ${state.customer.last_name}`,
              email: state.customer.email,
            },
          },
        },
      })
      .then((invoice) => {
        commit("SET_CART_LOADING", false)
        if (invoice.error) {
          commit("SET_CHECKOUT_ERROR", invoice.error.message)
          commit("SET_CART_LOADING", false)
          return
        }
        this.$posthog.capture("payment_complete")
        window.location.href = `/success/?order_id=${state.order.id}`
      })
      .catch((error) => {
        commit("SET_CHECKOUT_ERROR", error)
        commit("SET_CART_LOADING", false)
        this.$sentry.captureException(error)
      })
  },
  async getOrders({ commit, state, dispatch }, payload) {
    const filters = payload?.filters?.filters || []
    const date = payload?.filters?.date
    const filterQuery = generateFilterQuery(filters, date)
    const page = payload?.page || 1
    const limit = payload?.limit || 20
    let query = `?limit=${limit}&page=${page}${filterQuery}`
    if (payload.orderBy && payload.orderDirection) {
      query += `&orderBy=${payload.orderBy}&orderDirection=${payload.orderDirection}`
    }
    commit("SET_ACCOUNT_LOADING", true)
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    try {
      const response = await this.$axios.get(
        `${process.env.AND_DINE_API}/api/customers/orders${query}`,
        config
      )

      commit("SET_ORDERS", response.data.orders)
      commit("SET_ACCOUNT_LOADING", false)
    } catch (error) {
      commit("SET_ACCOUNT_LOADING", false)
      error.response?.data === "Invalid Token" && dispatch("customerLogout")
      this.$sentry.captureException(error)
    }
  },
  async getOrderById({ commit, state, dispatch }, id) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/customers/orders/${id}`, config)
      .then((response) => {
        commit("SET_CHOSEN_ORDER", response.data)
      })
      .catch((error) => {
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
      })
  },
  async getReviews({ commit }) {
    commit("SET_REVIEWS_LOADING", true)
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/public/reviews?limit=9999`)
      .then((response) => {
        commit("SET_REVIEWS", response.data.data)
        commit("SET_REVIEWS_LOADING", false)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
        commit("SET_REVIEWS", false)
        commit("SET_REVIEWS_LOADING", true)
      })
  },
  async createReview({ commit }, payload) {
    await this.$axios
      .post(
        `${process.env.AND_DINE_API}/api/public/reviews/${payload.id}`,
        payload.body
      )
      .then((response) => {
        commit("SET_REVIEW_MESSAGE", "Thanks for sharing")
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async getOrganisation({ commit, state, dispatch }) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    commit("SET_ORGANISATION_LOADING", true)
    await this.$axios
      .get(`${process.env.AND_DINE_API}/api/customers/organisations`, config)
      .then((response) => {
        commit("SET_ORGANISATION", response.data)
        commit("SET_ORGANISATION_LOADING", false)
      })
      .catch((error) => {
        commit("SET_ORGANISATION_LOADING", false)
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
      })
  },
  addOrgMember({ commit, state, dispatch }, payload) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    commit("SET_ORGANISATION_LOADING", true)
    this.$axios
      .put(
        `${process.env.AND_DINE_API}/api/customers/organisations/addCustomer/${payload.organisationId}`,
        { email: payload.email },
        config
      )
      .then(() => {
        dispatch("getOrganisation")
      })
      .catch((error) => {
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
        commit("SET_ORGANISATION_LOADING", false)
      })
  },
  removeOrgMember({ commit, state, dispatch }, payload) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    commit("SET_ORGANISATION_LOADING", true)
    this.$axios
      .put(
        `${process.env.AND_DINE_API}/api/customers/organisations/removeCustomer/${payload.organisationId}`,
        { email: payload.email },
        config
      )
      .then(() => {
        dispatch("getOrganisation")
      })
      .catch((error) => {
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
        commit("SET_ORGANISATION_LOADING", false)
      })
  },
  updateOrganisation({ commit, state, dispatch }, payload) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    commit("SET_ORGANISATION_LOADING", true)
    this.$axios
      .put(
        `${process.env.AND_DINE_API}/api/customers/organisations/${payload.organisationId}`,
        payload,
        config
      )
      .then(() => {
        dispatch("getOrganisation")
      })
      .catch((error) => {
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
        commit("SET_ORGANISATION_LOADING", false)
      })
  },
  downloadInvoice({ state, dispatch }, payload) {
    const config = {
      headers: {
        accept: "application/pdf",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/octet-stream; charset=utf-8",
      },
    }

    this.$axios
      .get(
        `${process.env.AND_DINE_API}/api/customers/orders/downloadInvoice/${payload.orderId}`,
        config
      )
      .then((res) => {
        function base64ToArrayBuffer(data) {
          const binaryString = window.atob(data)
          const binaryLen = binaryString.length
          const bytes = new Uint8Array(binaryLen)
          for (let i = 0; i < binaryLen; i++) {
            const ascii = binaryString.charCodeAt(i)
            bytes[i] = ascii
          }
          return bytes
        }
        const arrayBuffer = base64ToArrayBuffer(res.data)
        const url = window.URL.createObjectURL(
          new Blob([arrayBuffer], {
            type: "application/pdf",
          })
        )
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", `&Dine Invoice - ${payload.orderRef}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()
      })
      .catch((error) => {
        error.response?.data === "Invalid Token" && dispatch("customerLogout")
        this.$sentry.captureException(error)
      })
  },
  async getPayment({ commit }, payload) {
    const config = {
      headers: {
        accept: "application/pdf",
        "content-type": "application/octet-stream; charset=utf-8",
      },
    }
    commit("SET_PAYMENT_LOADING", true)
    await this.$axios
      .get(
        `${process.env.AND_DINE_API}/api/public/orders/payment/${payload}`,
        config
      )
      .then((response) => {
        commit("SET_PAYMENT_LOADING", false)
        commit("SET_ORDER", {
          ...response.data.orders[0],
          paymentIntent: response.data.paymentIntent,
        })
      })
      .catch((error) => {
        commit("SET_PAYMENT_LOADING", false)
        this.$sentry.captureException(error)
        this.$router.push("/404")
      })
  },
  async updatePurchaseOrder({ commit }, payload) {
    const config = {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
    }
    await this.$axios
      .put(
        `${process.env.AND_DINE_API}/api/public/orders/purchaseOrder`,
        payload,
        config
      )
      .then(() => {
        commit("SET_PURCHASE_ORDER_LOADING", false)
      })
      .catch((error) => {
        commit("SET_PURCHASE_ORDER_LOADING", false)
        commit(
          "SET_PURCHASE_ORDER_ERROR",
          "An error has occurred, please contact your sales representative if you wish to add your purchase order"
        )
        this.$sentry.captureException(error)
      })
  },
  async getCustomerPackageStructure({ state, commit }, payload) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    try {
      const response = await this.$axios(
        `${process.env.AND_DINE_API}/api/customers/subConfig`,
        config
      )
      commit("SET_ORG_PACKAGE_CHOICES", response.data)
    } catch (error) {
      this.$sentry.captureException(error)
    }
  },
  async getSubscriptionTypes({ commit }) {
    const config = {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
    }
    try {
      const response = await this.$axios(
        `${process.env.AND_DINE_API}/api/public/subConfig/subscriptionTypes`,
        config
      )
      commit("SET_SUBSCRIPTION_TYPES", response.data)
    } catch (error) {
      this.$sentry.captureException(error)
    }
  },
  async getPackageTypes({ commit }) {
    const config = {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
    }
    try {
      const response = await this.$axios(
        `${process.env.AND_DINE_API}/api/public/subConfig/packageTypes`,
        config
      )
      commit("SET_PACKAGE_TYPES", response.data)
    } catch (error) {
      this.$sentry.captureException(error)
    }
  },
  async getDefaultSubscriptionConfigurations({ commit }, payload) {
    const config = {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
    }
    try {
      const response = await this.$axios(
        `${process.env.AND_DINE_API}/api/public/subConfig/${payload}`,
        config
      )
      commit("SET_DEFAULT_PACKAGE_CHOICES", response.data)
    } catch (error) {
      this.$sentry.captureException(error)
    }
  },
  async updateOrderPackage({ commit, state }, payload) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }

    const { orderId, items, packages, note } = payload
    commit("SET_UPDATE_PRODUCTS_LOADING", true)

    try {
      await this.$axios.put(
        `${process.env.AND_DINE_API}/api/customers/orders/updatePackage/${orderId}`,
        { items, packages, note },
        config
      )

      commit("SET_UPDATE_PRODUCTS_ERROR", false)

      await this.$axios(
        `${process.env.AND_DINE_API}/api/customers/orders?orderBy=delivery_date_time&orderDirection=DESC`,
        config
      ).then((response) => {
        commit("SET_UPDATE_PRODUCTS_LOADING", false)
        commit("SET_ORDERS", response.data.orders)
      })
    } catch (error) {
      commit("SET_UPDATE_PRODUCTS_LOADING", false)
      commit(
        "SET_UPDATE_PRODUCTS_ERROR",
        "There was an error updating products for this order. If this error persists please reach out to support."
      )
      this.$sentry.captureException(error)
    }
  },
  async cancelDailyOrder({ commit, state }, payload) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }

    commit("SET_CANCEL_DAILY_LOADING", true)

    try {
      await this.$axios.put(
        `${process.env.AND_DINE_API}/api/customers/orders/cancelPremiumOrder/${payload}`,
        {},
        config
      )

      commit("SET_CANCEL_DAILY_ERROR", false)

      await this.$axios(
        `${process.env.AND_DINE_API}/api/customers/orders?orderBy=delivery_date_time&orderDirection=DESC`,
        config
      ).then((response) => {
        commit("SET_CANCEL_DAILY_LOADING", false)
        commit("SET_ORDERS", response.data.orders)
      })
    } catch (error) {
      commit("SET_CANCEL_DAILY_LOADING", false)
      commit(
        "SET_CANCEL_DAILY_ERROR",
        "There was an error cancelling this order. If this error persists please reach out to support."
      )
      this.$sentry.captureException(error)
    }
  },
  async getPremiumCutOffDay({ commit, state }) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }

    try {
      const response = await this.$axios(
        `${process.env.AND_DINE_API}/api/customers/orders/premiumCutOff`,
        config
      )

      commit("SET_PREMIUM_CUT_OFF_DAY", response.data.cut_off_day)
    } catch (error) {
      this.$sentry.captureException(error)
    }
  },
  async getOrganisationOrders({ commit, state }) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    await this.$axios
      .get(
        `${process.env.AND_DINE_API}/api/customers/orders/searchOrdersByOrganisation`,
        config
      )
      .then((response) => {
        commit("SET_ORGANISATION_ORDERS", response.data.orders)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async getOrganisationOrderProducts({ commit, state }) {
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    await this.$axios
      .get(
        `${process.env.AND_DINE_API}/api/customers/orders/orderProducts`,
        config
      )
      .then((response) => {
        commit("SET_ORGANISATION_ORDER_PRODUCTS", response.data.orderProducts)
      })
      .catch((error) => {
        this.$sentry.captureException(error)
      })
  },
  async appendProductToOrder({ commit, state }, payload) {
    const { orderId, items } = payload
    const config = {
      headers: {
        accept: "application/json",
        "x-access-token-customer": state.authenticated.token,
        "content-type": "application/json",
      },
    }
    commit("SET_APPEND_PRODUCTS_LOADING", true)
    try {
      await this.$axios.put(
        `${process.env.AND_DINE_API}/api/customers/orders/addToOrder/${orderId}`,
        { items },
        config
      )

      const [ordersResponse, orderProductsResponse] = await Promise.all([
        this.$axios.get(
          `${process.env.AND_DINE_API}/api/customers/orders/searchOrdersByOrganisation`,
          config
        ),
        this.$axios.get(
          `${process.env.AND_DINE_API}/api/customers/orders/orderProducts`,
          config
        ),
      ])

      commit("SET_ORGANISATION_ORDERS", ordersResponse.data.orders)
      commit(
        "SET_ORGANISATION_ORDER_PRODUCTS",
        orderProductsResponse.data.orderProducts
      )

      commit("SET_APPEND_PRODUCTS_ERROR", false)
      commit("SET_APPEND_PRODUCTS_LOADING", false)
    } catch (error) {
      commit("SET_APPEND_PRODUCTS_LOADING", false)
      this.$sentry.captureException(error)
      if (error.message.includes("Not enough notice to add product to order")) {
        commit(
          "SET_APPEND_PRODUCTS_ERROR",
          "The deadline to add your selection to the order has passed. If you think this is incorrect please reach out to support."
        )
      } else if (
        error.message.includes(
          `Product has already been added to order ${orderId} for customer with id`
        )
      ) {
        commit(
          "SET_APPEND_PRODUCTS_ERROR",
          "You have already added your selection to this order. If you think this is incorrect please reach out to support."
        )
      } else {
        commit(
          "SET_APPEND_PRODUCTS_ERROR",
          "There was an error adding your selection to this order. If this error persists please reach out to support."
        )
      }
    }
  },
}

export const getters = {
  openMakers: (state) => {
    return (
      state.makers &&
      state.makers?.filter(
        (maker) =>
          maker.is_active &&
          maker.makersCategories.some(
            (category) => category.is_active && category.biz
          )
      )
    )
  },
  closedMakers: (state) => {
    return (
      state.makers &&
      state.makers?.filter(
        (maker) =>
          !maker.is_active &&
          maker.attachments?.logo?.length > 0 &&
          maker.attachments?.profile?.length > 0 &&
          maker.makersCategories.some(
            (category) => category.is_active && category.biz
          )
      )
    )
  },
  previousMakers: (state) => {
    return (
      state.orders &&
      state.makers &&
      state.makers?.filter(
        (maker) =>
          JSON.stringify(state.orders).includes(maker.id) &&
          maker.is_active &&
          maker.makersCategories.some(
            (category) => category.is_active && category.biz
          )
      )
    )
  },
  cartItemCount: (state) => {
    let count = 0
    state.cart?.items?.length > 0
      ? state.cart.items.forEach((item) => {
          count += item.quantity
        })
      : (count = 0)
    return count
  },
  topReviews: (state) => {
    const top = state.reviews.filter(
      (review) => review.score >= 4 && review.customer
    )
    return Array.from(
      top
        .reduce((uniqueCustomers, review) => {
          const customer = review.customer
          if (!uniqueCustomers.has(customer)) {
            uniqueCustomers.set(customer, review)
          }
          return uniqueCustomers
        }, new Map())
        .values()
    )
  },
  navItems: (state) => {
    return [
      {
        id: 1,
        icon: "hand-wave",
        name: "about",
        value: "About us",
        link: "/about",
      },
      {
        id: 2,
        icon: "hat-chef",
        name: "join",
        value: "Become a Maker",
        link: "/join",
      },
      {
        id: 3,
        icon: "phone",
        name: "enquire",
        value: "Contact us",
        external: "https://landing.anddine.co.uk/enquire",
      },
    ]
  },
}
